import legoInitLite from "./base";
import Logger from "../utils/log";
import visitOrderTracking from "../plugins/lego-visit-order-tracking";
import visitStackTracking from "../plugins/lego-visit-stack-tracking";
import calcUserStayTimeInit from "../plugins/lego-user-stay-time";
import setClostMarkByPageId from "../plugins/lego-closemark-by-pageid";
import pullMiniH5OCD from "../plugins/lego-pull-mini-h5-ocd";
import { startMutationObserver } from "../plugins/lego-start-mutation-observer";
var legoInit = function legoInit() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    log: false,
    forbidLegoInPrerender: true
  };
  try {
    params = Object.assign({
      autoOcd: true
    }, params);
    // init基础版本
    legoInitLite(params);
    // 小程序环境并且需要拉取挂件cdn资源
    if (params.t === '103' && location.href.indexOf('hasOcdPermission=1') > -1) {
      pullMiniH5OCD();
    }
    // 开启mutationObserver
    startMutationObserver(params.autoGoodsExpose === undefined ? false : params.autoGoodsExpose, params.autoAreaExpose === undefined ? true : params.autoAreaExpose);
    // 根据参数默认开启的插件
    visitOrderTracking(params, legoInit); // 自动埋点逻辑初始化
    visitStackTracking(); // 初始化页面展现钩子逻辑
    // 开启统计页面停留时长功能
    if (params.routeList && params.stayUserTime) {
      try {
        calcUserStayTimeInit();
      } catch (err) {
        Logger.error("\u5F00\u542F\u7EDF\u8BA1\u9875\u9762\u505C\u7559\u65F6\u957F\u529F\u80FD\u51FA\u9519".concat(err));
      }
    }
    // init中开启setCloseMark，会默认使用pageId为每个页面设置 setCloseMark
    if (params.routeList && params.setCloseMark) {
      try {
        setClostMarkByPageId();
      } catch (err) {
        Logger.error("\u5F00\u542F\u9875\u9762\u81EA\u52A8setCloseMark\u51FA\u9519".concat(err));
      }
    }
  } catch (err) {
    Logger.error(err);
  }
};
legoInit.resumePV = function () {};
legoInit.userBackup = {};
legoInit.getUserBackup = function () {
  return legoInit.userBackup;
};
legoInit.setUserBackup = function (param) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (param) {
    legoInit.userBackup = Object.assign({}, legoInit.userBackup, param);
    if (opts.isAllData) {
      window['zz_lego_backup'] = Object.assign({}, window['zz_lego_backup'], this.userBackup);
    }
    legoInit.userBackup.pagequery && (window['zz_lego_backup'].pagequery = legoInit.userBackup.pagequery);
    legoInit.userBackup.subpageID && (window['zz_lego_backup'].subpageID = legoInit.userBackup.subpageID);
    legoInit.userBackup.postid && (window['zz_lego_backup'].postid = legoInit.userBackup.postid);
    legoInit.userBackup.ABContent && (window['zz_lego_backup'].ABContent = legoInit.userBackup.ABContent);
    legoInit.userBackup.mchannel && (window['zz_lego_backup'].mchannel = legoInit.userBackup.mchannel);
  }
};
export default legoInit;